module.exports = __webpack_public_path__ + "static/media/ico-credit.53645561.svg";